import {
  Component,
  ChangeDetectionStrategy,
  Input,
  ChangeDetectorRef,
  OnChanges,
  SimpleChanges,
  inject,
} from '@angular/core';
import { EMPTY, of, Subscription } from 'rxjs';
import { delay } from 'rxjs/operators';

@Component({
  selector: 'app-loader-wrapper',
  templateUrl: './loader-wrapper.component.html',
  styleUrls: ['./loader-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoaderWrapperComponent implements OnChanges {
  private readonly cdr = inject(ChangeDetectorRef);

  @Input() loading = false;

  debouncedLoading = false;
  private debounce$?: Subscription;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.loading.currentValue) {
      this.debounce$ = of(EMPTY)
        .pipe(delay(300))
        .subscribe(() => {
          this.debouncedLoading = true;
          this.cdr.markForCheck();
        });
    } else {
      this.debounce$?.unsubscribe();
      this.debouncedLoading = false;
    }

    this.cdr.markForCheck();
  }
}
